/* Publish by EComposer at 2026-10-02 09:55:25*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-642xjbsp0vb"]=  window.__ectimmers["ecom-642xjbsp0vb"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-642xjbsp0vb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-642xjbsp0vb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bxis5ursbx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bxis5ursbx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wxs59h3kzz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wxs59h3kzz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-27ag4yi8d89').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-27ag4yi8d89', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9o3nwc9ak6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9o3nwc9ak6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5g0hyo591jj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5g0hyo591jj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xof4wlqvobs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xof4wlqvobs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j5jrluv9rmg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5jrluv9rmg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lbc5r4eha7p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lbc5r4eha7p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4vd04nj7gab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4vd04nj7gab', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-464yd08v2a1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-464yd08v2a1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ul29gobl11p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ul29gobl11p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h61r1masm5b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h61r1masm5b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qethdzhaeq9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qethdzhaeq9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-koqsvvpxs2p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-koqsvvpxs2p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mwhs55vfel').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mwhs55vfel', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gjoc91jf3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gjoc91jf3q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aqjkiq52dim').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aqjkiq52dim', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k8nkjqnr4in').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k8nkjqnr4in', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rnbe7rrqoca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rnbe7rrqoca', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-frq99m25t0i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-frq99m25t0i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cbwr4647b0g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cbwr4647b0g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7g3sabjq8u9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7g3sabjq8u9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1f0wnakazf4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1f0wnakazf4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xql5gmiyyre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xql5gmiyyre', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m3hculpj8la').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m3hculpj8la', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7762gw8y4bn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7762gw8y4bn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-08jzrajl5js').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-08jzrajl5js', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6q6bs61wxwu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6q6bs61wxwu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-whv69sncz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-whv69sncz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1q6ie5y8fw7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1q6ie5y8fw7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n2qvhcfw8ng').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n2qvhcfw8ng', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vqpol1d5r1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vqpol1d5r1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vsn1ly0ipga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vsn1ly0ipga', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d30qejy075u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d30qejy075u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5hbuuogrx1y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5hbuuogrx1y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z6o9rzcuqup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z6o9rzcuqup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dqiwnue4o8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dqiwnue4o8h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z3i1tdjhwx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z3i1tdjhwx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nhsowdzvyzb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nhsowdzvyzb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99u2fihnxc9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99u2fihnxc9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6qrqfqv9mco').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6qrqfqv9mco', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ack4n99skjq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ack4n99skjq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1wk99sdoart').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1wk99sdoart', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dyomhvny79d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dyomhvny79d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b3qkkn0v66i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b3qkkn0v66i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7roq5c0hyd5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7roq5c0hyd5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vacyzqyvp8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vacyzqyvp8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ycmab7pgbe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ycmab7pgbe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x5wfx0m70v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x5wfx0m70v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-52o9tokffgb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-52o9tokffgb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7350hhdfe68').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7350hhdfe68', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l2wk3o01rg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l2wk3o01rg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-suyxo4hoofo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-suyxo4hoofo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o1l3b33otg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o1l3b33otg', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-k81oc7g2el"]=  window.__ectimmers["ecom-k81oc7g2el"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-k81oc7g2el"]["j58dnuex3"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-k81oc7g2el').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k81oc7g2el', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-id5x6bvklfc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-id5x6bvklfc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6llym7ypqrw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6llym7ypqrw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xmpk361rlf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xmpk361rlf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8cpveq2xdia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8cpveq2xdia', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jrdnckftscm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jrdnckftscm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p3tb1egxkr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p3tb1egxkr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v38eub2vuvi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v38eub2vuvi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yi7m7n8560m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yi7m7n8560m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ne5gv450w4i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ne5gv450w4i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w9xf5flpxj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w9xf5flpxj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lert2ojzit8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lert2ojzit8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qg8fdpgm6ea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qg8fdpgm6ea', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7weiozgjeh6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7weiozgjeh6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2l31d5hcex7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2l31d5hcex7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-twna30z7nc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-twna30z7nc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-65cmyawvlpc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-65cmyawvlpc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jlhih8revf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jlhih8revf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rpipp5tgnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rpipp5tgnl', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1d4sl57yor5"]=  window.__ectimmers["ecom-1d4sl57yor5"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,o=($=this.settings.disable_auto_close__tablet)!=null?$:!1,n=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function f(L){return n&&L<768||o&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let X=null;function G(oe){X||(X=oe);const se=Math.min((oe-X)/Z,1),U=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*U),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,X=Z.querySelector(":scope > .ecom-accordion__body");!r&&X&&X.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");X&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{X.style.height=X.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),U=this.parentNode,de=U.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),ee=U.querySelector(":scope > .ecom-accordion__body");U.classList&&U.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=f(se);if(q)J?(this.classList.remove("ecom-item-active"),U.classList.remove("ecom-item-active"),y(U)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),U.classList.add("ecom-item-active");let fe=U.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&ee&&ee.classList.add("ecom-effect-accodion"),b(ee)}window.dispatchEvent(new window.Event("renderScroll"));const K=this,ue=s||se>1024;function Y(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(K)&&k(K)}if(ue&&!r){let fe;const Te=function(Ce){Ce.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},600)}else requestAnimationFrame(()=>{setTimeout(Y,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-1d4sl57yor5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1d4sl57yor5', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2wibyvkq09g"]=  window.__ectimmers["ecom-2wibyvkq09g"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-2wibyvkq09g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2wibyvkq09g', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i6cgc7pqji').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i6cgc7pqji', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t5epq17q9xn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t5epq17q9xn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mqjpq6ff09').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mqjpq6ff09', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-twadx2nn66q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-twadx2nn66q', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5vjopn6airf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5vjopn6airf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-katpus345xq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-katpus345xq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-avwfb1l6zya').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-avwfb1l6zya', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vam98ikgo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vam98ikgo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hm3vjoiof0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hm3vjoiof0s', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3soehmsv68c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3soehmsv68c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xwen9j2db3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xwen9j2db3h', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-36mnmu8ugc4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-36mnmu8ugc4', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cucs1i8qgz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cucs1i8qgz', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kn8l4oa70e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kn8l4oa70e', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xvtyt4prw3a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xvtyt4prw3a', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1fl7ic2ksqcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1fl7ic2ksqcj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g655vu28sk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g655vu28sk9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fapelvye7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fapelvye7c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5br1i7tldfm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5br1i7tldfm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6r8sae9323s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6r8sae9323s', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ax8aiegfcfv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ax8aiegfcfv', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-77fguh1z61').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-77fguh1z61', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xnzy9yhknde').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xnzy9yhknde', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ka6alr022o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ka6alr022o', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tyzxsm48y2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tyzxsm48y2', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}